import { Directive, ElementRef, Input } from '@angular/core';

@Directive({
    selector: '[stylePreference]',
})
export class StylePreferenceDirective {
    @Input()
    public textColor: string;

    @Input()
    public backgroundColor: string;

    constructor(private elementReference: ElementRef) {}
    // gets called whenever one of the inputs changes
    public ngOnChanges(): void {
        // changes color of the text
        if (this.textColor) {
            this.elementReference.nativeElement.style.color = this.textColor;
        }

        if (this.backgroundColor) {
            // changes color of the background
            this.elementReference.nativeElement.style.background = this.backgroundColor;
        }
    }
}
